const map = {
	"./AD.png": "./src/core/assets/flags/AD.png",
	"./AE.png": "./src/core/assets/flags/AE.png",
	"./AF.png": "./src/core/assets/flags/AF.png",
	"./AG.png": "./src/core/assets/flags/AG.png",
	"./AI.png": "./src/core/assets/flags/AI.png",
	"./AL.png": "./src/core/assets/flags/AL.png",
	"./AM.png": "./src/core/assets/flags/AM.png",
	"./AO.png": "./src/core/assets/flags/AO.png",
	"./AQ.png": "./src/core/assets/flags/AQ.png",
	"./AR.png": "./src/core/assets/flags/AR.png",
	"./AS.png": "./src/core/assets/flags/AS.png",
	"./AT.png": "./src/core/assets/flags/AT.png",
	"./AU.png": "./src/core/assets/flags/AU.png",
	"./AW.png": "./src/core/assets/flags/AW.png",
	"./AX.png": "./src/core/assets/flags/AX.png",
	"./AZ.png": "./src/core/assets/flags/AZ.png",
	"./BA.png": "./src/core/assets/flags/BA.png",
	"./BB.png": "./src/core/assets/flags/BB.png",
	"./BD.png": "./src/core/assets/flags/BD.png",
	"./BE.png": "./src/core/assets/flags/BE.png",
	"./BF.png": "./src/core/assets/flags/BF.png",
	"./BG.png": "./src/core/assets/flags/BG.png",
	"./BH.png": "./src/core/assets/flags/BH.png",
	"./BI.png": "./src/core/assets/flags/BI.png",
	"./BJ.png": "./src/core/assets/flags/BJ.png",
	"./BL.png": "./src/core/assets/flags/BL.png",
	"./BM.png": "./src/core/assets/flags/BM.png",
	"./BN.png": "./src/core/assets/flags/BN.png",
	"./BO.png": "./src/core/assets/flags/BO.png",
	"./BR.png": "./src/core/assets/flags/BR.png",
	"./BS.png": "./src/core/assets/flags/BS.png",
	"./BT.png": "./src/core/assets/flags/BT.png",
	"./BV.png": "./src/core/assets/flags/BV.png",
	"./BW.png": "./src/core/assets/flags/BW.png",
	"./BY.png": "./src/core/assets/flags/BY.png",
	"./BZ.png": "./src/core/assets/flags/BZ.png",
	"./CA.png": "./src/core/assets/flags/CA.png",
	"./CC.png": "./src/core/assets/flags/CC.png",
	"./CD.png": "./src/core/assets/flags/CD.png",
	"./CF.png": "./src/core/assets/flags/CF.png",
	"./CG.png": "./src/core/assets/flags/CG.png",
	"./CH.png": "./src/core/assets/flags/CH.png",
	"./CI.png": "./src/core/assets/flags/CI.png",
	"./CK.png": "./src/core/assets/flags/CK.png",
	"./CL.png": "./src/core/assets/flags/CL.png",
	"./CM.png": "./src/core/assets/flags/CM.png",
	"./CN.png": "./src/core/assets/flags/CN.png",
	"./CO.png": "./src/core/assets/flags/CO.png",
	"./CR.png": "./src/core/assets/flags/CR.png",
	"./CU.png": "./src/core/assets/flags/CU.png",
	"./CV.png": "./src/core/assets/flags/CV.png",
	"./CW.png": "./src/core/assets/flags/CW.png",
	"./CX.png": "./src/core/assets/flags/CX.png",
	"./CY.png": "./src/core/assets/flags/CY.png",
	"./CZ.png": "./src/core/assets/flags/CZ.png",
	"./DE.png": "./src/core/assets/flags/DE.png",
	"./DJ.png": "./src/core/assets/flags/DJ.png",
	"./DK.png": "./src/core/assets/flags/DK.png",
	"./DM.png": "./src/core/assets/flags/DM.png",
	"./DO.png": "./src/core/assets/flags/DO.png",
	"./DZ.png": "./src/core/assets/flags/DZ.png",
	"./EC.png": "./src/core/assets/flags/EC.png",
	"./EE.png": "./src/core/assets/flags/EE.png",
	"./EG.png": "./src/core/assets/flags/EG.png",
	"./EH.png": "./src/core/assets/flags/EH.png",
	"./ER.png": "./src/core/assets/flags/ER.png",
	"./ES.png": "./src/core/assets/flags/ES.png",
	"./ET.png": "./src/core/assets/flags/ET.png",
	"./FI.png": "./src/core/assets/flags/FI.png",
	"./FJ.png": "./src/core/assets/flags/FJ.png",
	"./FK.png": "./src/core/assets/flags/FK.png",
	"./FM.png": "./src/core/assets/flags/FM.png",
	"./FO.png": "./src/core/assets/flags/FO.png",
	"./FR.png": "./src/core/assets/flags/FR.png",
	"./GA.png": "./src/core/assets/flags/GA.png",
	"./GB-SCT.png": "./src/core/assets/flags/GB-SCT.png",
	"./GB.png": "./src/core/assets/flags/GB.png",
	"./GD.png": "./src/core/assets/flags/GD.png",
	"./GE.png": "./src/core/assets/flags/GE.png",
	"./GF.png": "./src/core/assets/flags/GF.png",
	"./GG.png": "./src/core/assets/flags/GG.png",
	"./GH.png": "./src/core/assets/flags/GH.png",
	"./GI.png": "./src/core/assets/flags/GI.png",
	"./GL.png": "./src/core/assets/flags/GL.png",
	"./GM.png": "./src/core/assets/flags/GM.png",
	"./GN.png": "./src/core/assets/flags/GN.png",
	"./GP.png": "./src/core/assets/flags/GP.png",
	"./GQ.png": "./src/core/assets/flags/GQ.png",
	"./GR.png": "./src/core/assets/flags/GR.png",
	"./GS.png": "./src/core/assets/flags/GS.png",
	"./GT.png": "./src/core/assets/flags/GT.png",
	"./GU.png": "./src/core/assets/flags/GU.png",
	"./GW.png": "./src/core/assets/flags/GW.png",
	"./GY.png": "./src/core/assets/flags/GY.png",
	"./HK.png": "./src/core/assets/flags/HK.png",
	"./HM.png": "./src/core/assets/flags/HM.png",
	"./HN.png": "./src/core/assets/flags/HN.png",
	"./HR.png": "./src/core/assets/flags/HR.png",
	"./HT.png": "./src/core/assets/flags/HT.png",
	"./HU.png": "./src/core/assets/flags/HU.png",
	"./ID.png": "./src/core/assets/flags/ID.png",
	"./IE.png": "./src/core/assets/flags/IE.png",
	"./IL.png": "./src/core/assets/flags/IL.png",
	"./IM.png": "./src/core/assets/flags/IM.png",
	"./IN.png": "./src/core/assets/flags/IN.png",
	"./IO.png": "./src/core/assets/flags/IO.png",
	"./IQ.png": "./src/core/assets/flags/IQ.png",
	"./IR.png": "./src/core/assets/flags/IR.png",
	"./IS.png": "./src/core/assets/flags/IS.png",
	"./IT.png": "./src/core/assets/flags/IT.png",
	"./JE.png": "./src/core/assets/flags/JE.png",
	"./JM.png": "./src/core/assets/flags/JM.png",
	"./JO.png": "./src/core/assets/flags/JO.png",
	"./JP.png": "./src/core/assets/flags/JP.png",
	"./KE.png": "./src/core/assets/flags/KE.png",
	"./KG.png": "./src/core/assets/flags/KG.png",
	"./KH.png": "./src/core/assets/flags/KH.png",
	"./KI.png": "./src/core/assets/flags/KI.png",
	"./KM.png": "./src/core/assets/flags/KM.png",
	"./KN.png": "./src/core/assets/flags/KN.png",
	"./KP.png": "./src/core/assets/flags/KP.png",
	"./KR.png": "./src/core/assets/flags/KR.png",
	"./KW.png": "./src/core/assets/flags/KW.png",
	"./KY.png": "./src/core/assets/flags/KY.png",
	"./KZ.png": "./src/core/assets/flags/KZ.png",
	"./LA.png": "./src/core/assets/flags/LA.png",
	"./LB.png": "./src/core/assets/flags/LB.png",
	"./LC.png": "./src/core/assets/flags/LC.png",
	"./LI.png": "./src/core/assets/flags/LI.png",
	"./LK.png": "./src/core/assets/flags/LK.png",
	"./LR.png": "./src/core/assets/flags/LR.png",
	"./LS.png": "./src/core/assets/flags/LS.png",
	"./LT.png": "./src/core/assets/flags/LT.png",
	"./LU.png": "./src/core/assets/flags/LU.png",
	"./LV.png": "./src/core/assets/flags/LV.png",
	"./LY.png": "./src/core/assets/flags/LY.png",
	"./MA.png": "./src/core/assets/flags/MA.png",
	"./MC.png": "./src/core/assets/flags/MC.png",
	"./MD.png": "./src/core/assets/flags/MD.png",
	"./ME.png": "./src/core/assets/flags/ME.png",
	"./MF.png": "./src/core/assets/flags/MF.png",
	"./MG.png": "./src/core/assets/flags/MG.png",
	"./MH.png": "./src/core/assets/flags/MH.png",
	"./MK.png": "./src/core/assets/flags/MK.png",
	"./ML.png": "./src/core/assets/flags/ML.png",
	"./MM.png": "./src/core/assets/flags/MM.png",
	"./MN.png": "./src/core/assets/flags/MN.png",
	"./MO.png": "./src/core/assets/flags/MO.png",
	"./MP.png": "./src/core/assets/flags/MP.png",
	"./MQ.png": "./src/core/assets/flags/MQ.png",
	"./MR.png": "./src/core/assets/flags/MR.png",
	"./MS.png": "./src/core/assets/flags/MS.png",
	"./MT.png": "./src/core/assets/flags/MT.png",
	"./MU.png": "./src/core/assets/flags/MU.png",
	"./MV.png": "./src/core/assets/flags/MV.png",
	"./MW.png": "./src/core/assets/flags/MW.png",
	"./MX.png": "./src/core/assets/flags/MX.png",
	"./MY.png": "./src/core/assets/flags/MY.png",
	"./MZ.png": "./src/core/assets/flags/MZ.png",
	"./NA.png": "./src/core/assets/flags/NA.png",
	"./NC.png": "./src/core/assets/flags/NC.png",
	"./NE.png": "./src/core/assets/flags/NE.png",
	"./NF.png": "./src/core/assets/flags/NF.png",
	"./NG.png": "./src/core/assets/flags/NG.png",
	"./NI.png": "./src/core/assets/flags/NI.png",
	"./NL.png": "./src/core/assets/flags/NL.png",
	"./NO.png": "./src/core/assets/flags/NO.png",
	"./NP.png": "./src/core/assets/flags/NP.png",
	"./NR.png": "./src/core/assets/flags/NR.png",
	"./NU.png": "./src/core/assets/flags/NU.png",
	"./NZ.png": "./src/core/assets/flags/NZ.png",
	"./OM.png": "./src/core/assets/flags/OM.png",
	"./PA.png": "./src/core/assets/flags/PA.png",
	"./PE.png": "./src/core/assets/flags/PE.png",
	"./PF.png": "./src/core/assets/flags/PF.png",
	"./PG.png": "./src/core/assets/flags/PG.png",
	"./PH.png": "./src/core/assets/flags/PH.png",
	"./PK.png": "./src/core/assets/flags/PK.png",
	"./PL.png": "./src/core/assets/flags/PL.png",
	"./PM.png": "./src/core/assets/flags/PM.png",
	"./PN.png": "./src/core/assets/flags/PN.png",
	"./PR.png": "./src/core/assets/flags/PR.png",
	"./PS.png": "./src/core/assets/flags/PS.png",
	"./PT.png": "./src/core/assets/flags/PT.png",
	"./PW.png": "./src/core/assets/flags/PW.png",
	"./PY.png": "./src/core/assets/flags/PY.png",
	"./QA.png": "./src/core/assets/flags/QA.png",
	"./RE.png": "./src/core/assets/flags/RE.png",
	"./RO.png": "./src/core/assets/flags/RO.png",
	"./RS.png": "./src/core/assets/flags/RS.png",
	"./RU.png": "./src/core/assets/flags/RU.png",
	"./RW.png": "./src/core/assets/flags/RW.png",
	"./SA.png": "./src/core/assets/flags/SA.png",
	"./SB.png": "./src/core/assets/flags/SB.png",
	"./SC.png": "./src/core/assets/flags/SC.png",
	"./SD.png": "./src/core/assets/flags/SD.png",
	"./SE.png": "./src/core/assets/flags/SE.png",
	"./SG.png": "./src/core/assets/flags/SG.png",
	"./SH.png": "./src/core/assets/flags/SH.png",
	"./SI.png": "./src/core/assets/flags/SI.png",
	"./SJ.png": "./src/core/assets/flags/SJ.png",
	"./SK.png": "./src/core/assets/flags/SK.png",
	"./SL.png": "./src/core/assets/flags/SL.png",
	"./SM.png": "./src/core/assets/flags/SM.png",
	"./SN.png": "./src/core/assets/flags/SN.png",
	"./SO.png": "./src/core/assets/flags/SO.png",
	"./SR.png": "./src/core/assets/flags/SR.png",
	"./SS.png": "./src/core/assets/flags/SS.png",
	"./ST.png": "./src/core/assets/flags/ST.png",
	"./SV.png": "./src/core/assets/flags/SV.png",
	"./SX.png": "./src/core/assets/flags/SX.png",
	"./SY.png": "./src/core/assets/flags/SY.png",
	"./SZ.png": "./src/core/assets/flags/SZ.png",
	"./TC.png": "./src/core/assets/flags/TC.png",
	"./TD.png": "./src/core/assets/flags/TD.png",
	"./TF.png": "./src/core/assets/flags/TF.png",
	"./TG.png": "./src/core/assets/flags/TG.png",
	"./TH.png": "./src/core/assets/flags/TH.png",
	"./TJ.png": "./src/core/assets/flags/TJ.png",
	"./TK.png": "./src/core/assets/flags/TK.png",
	"./TL.png": "./src/core/assets/flags/TL.png",
	"./TM.png": "./src/core/assets/flags/TM.png",
	"./TN.png": "./src/core/assets/flags/TN.png",
	"./TO.png": "./src/core/assets/flags/TO.png",
	"./TR.png": "./src/core/assets/flags/TR.png",
	"./TT.png": "./src/core/assets/flags/TT.png",
	"./TV.png": "./src/core/assets/flags/TV.png",
	"./TW.png": "./src/core/assets/flags/TW.png",
	"./TZ.png": "./src/core/assets/flags/TZ.png",
	"./UA.png": "./src/core/assets/flags/UA.png",
	"./UG.png": "./src/core/assets/flags/UG.png",
	"./US.png": "./src/core/assets/flags/US.png",
	"./UY.png": "./src/core/assets/flags/UY.png",
	"./UZ.png": "./src/core/assets/flags/UZ.png",
	"./VA.png": "./src/core/assets/flags/VA.png",
	"./VC.png": "./src/core/assets/flags/VC.png",
	"./VE.png": "./src/core/assets/flags/VE.png",
	"./VG.png": "./src/core/assets/flags/VG.png",
	"./VI.png": "./src/core/assets/flags/VI.png",
	"./VN.png": "./src/core/assets/flags/VN.png",
	"./VU.png": "./src/core/assets/flags/VU.png",
	"./WF.png": "./src/core/assets/flags/WF.png",
	"./WS.png": "./src/core/assets/flags/WS.png",
	"./XK.png": "./src/core/assets/flags/XK.png",
	"./YE.png": "./src/core/assets/flags/YE.png",
	"./YT.png": "./src/core/assets/flags/YT.png",
	"./ZA.png": "./src/core/assets/flags/ZA.png",
	"./ZM.png": "./src/core/assets/flags/ZM.png",
	"./ZW.png": "./src/core/assets/flags/ZW.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/core/assets/flags sync recursive ^\\.\\/.*\\.png$";